export const STILL_NEEDED = window.jQuery ? $.__('Still Needed') : 'Still Needed';
